const styles = () => ({
  referrersButton: {
    borderTopLeftRadius: '0px !important',
    borderBottomLeftRadius: '0px !important',
    position: 'relative',
    right: '1px',
    height: 'auto',
  },

  chipInputRoot: {
    borderRadius: '6px 0 0 6px',
    margin: '0',
    position: 'relative',
    zIndex: 100,
  },

  chipRoot: {
    margin: '1px 0',
  },
});

export default styles;
